export const testimonialsData = [
    {
        id: 1,
        feedback: "Alldoer handled everything—from sourcing custom Diwali decor to shipping it to the US. Smooth process, great quality, zero stress.",
        name: "Albus Dumbledore",
        organization: "Event Organizer",
        location: "USA",
        image: "https://images.unsplash.com/photo-1599566150163-29194dcaad36?auto=format&fit=crop&w=100&q=80",
    },
    {
        id: 2,
        feedback: "We needed uniforms with specific fabric and branding requirements. Alldoer sourced exactly what we needed and delivered on time.",
        name: "Severus Snape",
        organization: "Gifting Partner",
        location: "UK",
        image: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?auto=format&fit=crop&w=100&q=80",
    },
    {
        id: 3,
        feedback: "The quality control at source is what sets them apart. I didn't have to worry about a single damaged piece in our bulk order of 5000 units.",
        name: "Harry Potter",
        organization: "Team Leader @ Gryffindor",
        location: "",
        image: "https://images.unsplash.com/photo-1494790108377-be9c29b29330?auto=format&fit=crop&w=100&q=80",
    },
    {
        id: 4,
        feedback: "Their custom-first approach saved us weeks of negotiation. They found vendors who could match our exact sustainability specs.",
        name: "Hermione Granger",
        organization: "Operations Head",
        location: "DE",
        image: "https://images.unsplash.com/photo-1438761681033-6461ffad8d80?auto=format&fit=crop&w=100&q=80",
    },
    {
        id: 5,
        feedback: "Incredible logistics support. Sourcing from India usually gives us a headache with customs, but Alldoer made it seamless.",
        name: "Ron Weasley",
        organization: "Logistics Manager",
        location: "UK",
        image: "https://images.unsplash.com/photo-1500648767791-00dcc994a43e?auto=format&fit=crop&w=100&q=80",
    }
];